import ModalBody from './modalBody-TEMPLATE_VERSION'

export default ModalBody
